import React from 'react'

const Project1 = () => {
  return (
    <div className="container">
  <section className="member-details">
    <div className="container">
      <div className="row">
        <div className="col-lg-3 col-md-4">
          <div className="img-container">
            <img src="images/pro1.jpg" alt="team member" className="img-full" />
          </div>
        </div>
        <div className="col-lg-9 col-md-8">
          <div className="member_designation">
            <h2>Mianwali Discount Motel Building</h2>
            <span>CEO Bootdey</span>
          </div>
          <div className="member_desc">
            <p>
              Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt.ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
            </p>
            <ul className="styled_list">
              <li className><i className="fa fa-chevron-circle-right" aria-hidden="true" /> Morbi fermentum felis nec</li>
              <li className><i className="fa fa-chevron-circle-right" aria-hidden="true" /> Morbi fermentum felis nec gravida tempus.</li>
              <li className><i className="fa fa-chevron-circle-right" aria-hidden="true" /> Morbi fermentum felis nec gravida</li>
            </ul>
          </div>
         
          <div className="member_desc">
            <h4>Persional Information</h4>
            <p>
              Vinteger eu libero rutrum, imperdiet arcueniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem. accusantium doloremque laudantium.
            </p>
            
           
          </div>
         
        </div>
      </div>
    </div>
  </section>
</div>

  )
}

export default Project1